export const fleamarket = {
  purchase: {
    actionName: "商品購入",
  },
} as const;
